import Sentry from './sentry';
import { Integrations } from '@sentry/tracing';

import { environment } from './environment';
import { version } from '../../package.json';
import { TOKEN_INVALID_ERRCODE } from './config';

export const createSentryPlugin = (router: any) => ({
  install(app: any) {
    if (environment === 'production') {
      Sentry.init({
        app,
        dsn: 'https://ce4d9fc515a0446ab6e54d310d043de5@sentry2.pipacoding.com/15',
        ignoreErrors: ['ResizeObserver loop limit exceeded', 'RangeError'],
        denyUrls: ['datacenter.hetao101.com', 'sensors.hetao101.com'],
        integrations: [
          new Integrations.BrowserTracing({
            routingInstrumentation: Sentry.vueRouterInstrumentation(router),
            tracingOrigins: [
              'localhost',
              'contest.hetaodev.com',
              'match.testing7.hetao101.com',
              'match.hetao101.com',
              /^\//,
            ],
          }),
        ],
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,
        release: version,
        environment,
        debug: environment !== 'production',
        logErrors: environment !== 'production',
        normalizeDepth: 5,
        beforeSend(event: any, hint: any) {
          const { originalException } = hint;
          if (originalException) {
            if (originalException.errCode === TOKEN_INVALID_ERRCODE) {
              // Token校验，Token不匹配
              // 忽略掉用户登出的错误信息
              return null;
            }
          }
          return event;
        },
      });
    }
  },
});
